import { RequestWalletPinOtpUsecase } from '../../../usecase/fs-wallet-otp/request-wallet-pin-otp.usecase';
import { ValidateWalletPinOtpUsecase } from '../../../usecase/fs-wallet-otp/validate-wallet-pin-otp.usecase';
import { CheckPinUsecase } from '../../../usecase/fs-wallet-pin/check-pin.usecase';
import { SetPinUsecase } from '../../../usecase/fs-wallet-pin/set-pin.usecase';

export const WalletPinUseCasesProvider = [
    RequestWalletPinOtpUsecase,
    ValidateWalletPinOtpUsecase,
    CheckPinUsecase,
    SetPinUsecase,
];
